<template>
<div>

    <div class="box partner-box" @click="partner_modal = true">
        <img src="https://assets.webbank.com/partners/build_logo.png">
    </div>

<div class="modal" :class="{'is-active': partner_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div class="has-text-centered">
            <img src="https://assets.webbank.com/partners/build_logo.png" alt="Build Logo">
          </div>
            <br>
            <p>In partnership with Build, WebBank is the lender of the Build Credit Builder Loan.
                If you have questions about your account, please contact Build at (888) 242-7263.
                If you are interested in signing up for a Build Credit Builder Loan, click
                <a href="#" title="Build Credit Builder Loan" @click="$emit('link-click', 'https://app.getbuild.com/signup')">here</a>.</p>
            <br>
            <br>
            <p><a href="#" title="Build Privacy Policy and Privacy Notice" @click="$emit('link-click', 'https://getbuild.com/wp-content/uploads/2023/05/Privacy-Policy.pdf');">Build Privacy Policy and Privacy Notice</a></p>
            <br>
            <p><a href="#" title="WebBank Privacy Notice" @click="$emit('link-click', 'https://getbuild.com/wp-content/uploads/2023/06/WebBank-Privacy-Notice.pdf');">WebBank Privacy Notice</a></p>
            <br>
            <button class="button is-primary is-light" @click="partner_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="partner_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            partner_modal: false,
        }
    }
}
</script>
